module.exports = __webpack_public_path__ + "static/support-site-og-image-1556ddcb9034b94504fb4cc4d0eb30de.png";